import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { QrHelperProvider } from '../../providers/qr-helper/qr-helper';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';

import { LotDetailPage } from '../lot-detail/lot-detail';
declare var GibberishAES;

@Component({
  selector: 'page-qrscanner',
  templateUrl: 'qrscanner.html',
})

export class QrscannerPage {
  private scanSub: any ;
  public scanEventName = 'infoCode:scanned';
  public _scanEventFunction;
  private pushedPage = false;

  constructor(public navCtrl: NavController,
              private qrHelper: QrHelperProvider,
              public events: Events,
              public toastHelper: ToastHelperProvider) {
  }

  ionViewWillEnter(){
    this.pushedPage = false;
    this._scanEventFunction = text => {this.codeFound(text);}
    this.events.subscribe(this.scanEventName, this._scanEventFunction);
  }

  ionViewWillLeave(){
    this.qrHelper.destroyQr();
    this.events.unsubscribe(this.scanEventName, this._scanEventFunction);
  }

  startScan(){
    this.qrHelper.startQr(this.scanEventName, 'qr-reader-info');
  }
  stopScan(){
    this.qrHelper.destroyQr();
  }

  codeFound(text:string) {
    let qrObj = JSON.parse(text);
    console.log(qrObj);
    if (typeof(qrObj) === 'object' && 'section' in qrObj) {
      if(qrObj['section'] == 'lots'){
        if ('entryId' in qrObj) {
          this.toastHelper.showToast('SUCCES: lot gevonden.');
          if (!this.pushedPage) {
            this.navCtrl.push(LotDetailPage, {
              id: qrObj.entryId
            });
            this.pushedPage = true;
          }
        }else{
          this.toastHelper.showToast('ERROR: kon het lot ID niet afleiden uit de qr code.', 'error');
        }
      }else{
        this.toastHelper.showToast('ERROR: QR code is niet van een lot maar van: ' + qrObj['section'], 'error');
      }
    }else{
      this.toastHelper.showToast('ERROR: Onbekende QR code.', 'error');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qrscanner/qrscanner.ts